import type { IconData } from '@stacksjs/iconify-core'

export const controlButtonsSkipBack: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M5 10.286L15 16V0L5 5.714V1H1v14h4z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default controlButtonsSkipBack
